/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';

import { appStoreLink } from 'constants/urls';

const storeBadges: Record<string, string> = {
  cn: '/app-store/cn.svg',
  de: '/app-store/de.svg',
  enUS: '/app-store/en-us.svg',
  es: '/app-store/es.svg',
  fr: '/app-store/fr.svg',
  pl: '/app-store/pl.svg',
  pt: '/app-store/pt.svg',
  th: '/app-store/th.svg',
  nl: '/app-store/nl.svg',
  vi: '/app-store/vi.svg',
  ja: '/app-store/ja.svg',
  it: '/app-store/it.svg',
};

import s from './styles.module.scss';

interface AppStoreBadgeProps {
  language?: string;
}

const AppStoreBadge = ({ language = 'en-us' }: AppStoreBadgeProps) => (
  <a className={s.badge} href={appStoreLink} target="_blank" rel="noopener noreferrer">
    <img className={s.badgeImage} src={storeBadges[language] || '/app-store/en-us.svg'} alt="App store" />
  </a>
);

export default AppStoreBadge;
